"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getPartner_1 = __importDefault(require("./getPartner"));
const partners_1 = require("./partners");
const supportedJobs_1 = __importDefault(require("./supportedJobs"));
const getActivityInformation = (payload) => {
    const { HAS_PARTNER: hasPartner, INTITULE_JOB: job, PARTNER } = payload;
    if (hasPartner !== 'Non' || (PARTNER && PARTNER !== 'Non')) {
        const partner = getPartner_1.default(payload);
        const getInformation = partners_1.partners[partner];
        if (getInformation) {
            const activityInformation = getInformation(payload);
            if (activityInformation) {
                return activityInformation;
            }
        }
        // eslint-disable-next-line no-console
        console.warn(`Partner ${partner} is not supported`);
    }
    const activityInformation = job ? supportedJobs_1.default[job] : undefined;
    if (activityInformation) {
        return activityInformation;
    }
    // eslint-disable-next-line no-console
    console.warn(`INTITULE_JOB ${job} is not supported`);
    return {
        activityCategory: 'OTHER_JOB',
        activityType: '',
        craftsmanship: false,
        job: job || '',
    };
};
exports.default = getActivityInformation;
